export default {
  data() {
    return {
      formPrefUser: {
        page: {
          fav: "", // favourite page
          detail: "Tab", // document detail view
          register: "Detail", // register registr view
          home: "/userdash", // prefereed home page when browing app
          signin: "/appdash", // prefered page at login
          signout: "" // prefered page at sign out
        },
        search: {
          user: "company", // who can search you
          data: "", // restrtcions
          limit: "100",
          reg: "100",
          list: "25",
          sort: "Newest", // newwest first
          sortby: "Date",
          sorthow: "Ascending",
          result: "10",
          profile: "Public", // hwo much you reveal when others search you
          privacy: "Public", // what is displayed when others search you
          display: "50"
        },
        settings: {
          market: "Email", // marketing prefeenrces
          auth: "Email", // future is 2 Step Auth.
          theme: "Business",
          mode: "Light",
          date: "DD/MM/YYYY", // date format
          autologoff: "Enabled", // auto log off
          ln: "English" // language
        },
        view: {
          snackbar: true, // display snackbars
          barstatus: true, // display of status bat
          barbottom: true,
          barnavigation: true
        }
      },
      formPrefCompany: {
        search: {
          privacy: "Public", // what is displayed when others search you
          register: "10",
          search: "1000",
          load: "10",
          profile: "Public" // hwo much you reveal when others search you
        },
        settings: {
          archive: "Manual", // docu are archived manually
          risk: "F0-A5",
          pri: "6P",
          costu: "AUD",
          carbu: "kg",
          asset: "50", // asset attachments limit for Maintenance Plan
          reg: "25", // maximum number of registers attachements
          list: "10", // for other attachemens or lists
          data: "L1", // not possible to overwrite L1, and L2 ok to overwrite
          access: "4", // data access restrictions
          trans: "Public" // level of appral O is open and r is restructive
        },
        auth: {
          l0: "L1", // auth level
          l1: "L1",
          l2: "L1",
          l3: "L1",
          l4: "L1",
          l5: "L1",
          l6: "L1",
          l7: "L1",
          l8: "L1",
          l9: "L1"
        }
      },
      formPrefFacility: {
        search: {
          vendor: "Restricted",
          privacy: "Public", // what is displayed when others search you
          asset: "50" // asset register limit per object
        },
        settings: {
          access: "4", // data access restrictions
          view: "Manager", // for facility
          viewa: "Simple" // or detailed for asset
        },
        auth: {
          l0: "L1",
          l1: "L1", // auth level
          l2: "L1",
          l3: "L1",
          l4: "L1",
          l5: "L1",
          l6: "L1",
          l7: "L1",
          l8: "L1",
          l9: "L1"
        }
      }
    };
  }
};
